import React, { useState, useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';

import { useToast } from '../../../../../../../../hooks/toast';
import { useSimpleProduct } from '../../../../../../../../hooks/newSimpleProduct';

import { ModalWrapper, MenuOptionButton } from '../../../../../styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

interface DeleteComplementoProps {
  index: number;
  title_complemento: string;
}

interface ComplementoData {
  complemento_obrigatorio: boolean;
  descricao: string;
  qtd_min: number;
  qtd_max: number;
  tipo: number;
  empresa_id: number;
  index: number;
}

interface ItemComplementoData {
  codigo_complemento?: string;
  descricao: string;
  tipo: number;
  preco: number;
  imagem?: File;
  produto_id?: number;
  index_complemento: number;
  qtd_min: number;
  qtd_max: number;
}

const DeleteComplementoOption: React.FC<DeleteComplementoProps> = ({
  index,
  title_complemento,
}) => {
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  const { addToast } = useToast();
  const {
    complemento,
    itensComplemento,
    updateComplemento,
    updateItensComplemento,
  } = useSimpleProduct();

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleDeleteComplemento = useCallback(() => {
    const complementosUpdated: ComplementoData[] = [];
    const itensComplementoUpdated: ItemComplementoData[] = [];

    for (let i = 0; i < complemento.length; i += 1) {
      if (complemento[i].index !== index) {
        complementosUpdated.push(complemento[i]);
      }
    }

    for (let z = 0; z < itensComplemento.length; z += 1) {
      if (itensComplemento[z].index_complemento !== index) {
        itensComplementoUpdated.push(itensComplemento[z]);
      }
    }

    updateComplemento([...complementosUpdated]);
    updateItensComplemento([...itensComplementoUpdated]);

    addToast({
      type: 'info',
      title: `Complemento ${title_complemento} excluído.`,
    });
    handleClose();
  }, [
    complemento,
    itensComplemento,
    index,
    updateComplemento,
    updateItensComplemento,
    addToast,
    title_complemento,
  ]);

  return (
    <div>
      <MenuOptionButton type="button" onClick={handleOpen}>
        Excluir
      </MenuOptionButton>

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <ModalWrapper>
            <div className="header">
              <h1>Atenção</h1>

              <button type="button" onClick={handleClose}>
                <RiCloseLine size={30} />
              </button>
            </div>

            <div className="description">
              <span>Deseja excluir o complemento {title_complemento}?</span>
            </div>

            <div className="btnActions">
              <button
                type="button"
                className="confirm"
                onClick={handleDeleteComplemento}
              >
                Confirmar
              </button>

              <button type="button" className="cancel" onClick={handleClose}>
                Cancelar
              </button>
            </div>
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteComplementoOption;
